<template>
	<div>
		<div class="border-bottom mb-2">
		<router-link class=" mt-1 border-right border-left border-top rounded "
		 :to="{name:'SuppliersCustomerEditSecondSuretyIdentityInfo'}">
		<div class="btn ml-0 mr-0" :class="($route.name=='SuppliersCustomerEditSecondSuretyIdentityInfo')?'btn-outline-success':'btn-outline-primary'"> ویرایش اطلاعات هویتی</div>
		 </router-link>
		<router-link class=" mt-1 border-right border-left border-top rounded "
		 :to="{name:'SuppliersCustomerEditSecondSuretyResidentialInfo'}">
		<div class="btn ml-0 mr-0" :class="($route.name=='SuppliersCustomerEditSecondSuretyResidentialInfo')?'btn-outline-success':'btn-outline-primary'"> ویرایش اطلاعات سکونتی</div>
		 </router-link>
		<router-link class=" mt-1 border-right border-left border-top rounded "
		 :to="{name:'SuppliersCustomerEditSecondSuretyJobInfo'}">
		 <div class="btn ml-0 mr-0" :class="($route.name=='SuppliersCustomerEditSecondSuretyJobInfo')?'btn-outline-success':'btn-outline-primary'"> ویرایش اطلاعات شغلی</div>
		 </router-link>
		 <router-link class=" mt-1 border-right border-left border-top rounded "
		 :to="{name:'SuppliersCustomerSecondSuretyDocs'}">
		 <div class="btn ml-0 mr-0" :class="($route.name=='SuppliersCustomerSecondSuretyDocs')?'btn-outline-success':'btn-outline-primary'">مدارک</div>
		 </router-link>
		 </div>
		<section>
			<div class="container">
				<router-view></router-view>
				
				<!-- end of row -->
			</div>
			<!-- end of container -->
		</section>
		<!-- =========== End of Body ============ -->
	</div>
</template>
<script>

export default {
	data()
	{
		return {
			routePath:"",
			basePath:""
		}
	},
	mounted()
	{
		
	}

}
</script>



